export type Theme = 'dark' | 'light';

const STORAGE_KEY = 'coachtools.theme';

/**
 * The person's chosen theme, kept apart from the control that changes it.
 *
 * The switch lives on Account since 13 October, but every screen has to open in
 * the chosen theme, so main.tsx applies it before anything renders rather than
 * leaving that to a control that only mounts on one page.
 *
 * Dark is the default because that is what Recul and Aplomb already are;
 * tokens.css treats light as opt-in via data-theme="light".
 *
 * prefers-color-scheme is deliberately NOT consulted. The brief says the theme is
 * the user's choice, so reacting to the OS setting would be behaviour nobody
 * asked for (RE-05), and tokens.css says the same.
 *
 * localStorage access is wrapped: it throws in a private window with site data
 * blocked, and a theme is not worth taking the app down for. It is a per-device
 * convenience only, so losing it to storage eviction (RE-33) costs a tap.
 */
export const savedTheme = {
  read(): Theme {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
    } catch {
      return 'dark';
    }
  },

  apply(theme: Theme): void {
    document.documentElement.dataset['theme'] = theme;
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* preference simply will not persist */
    }
  },
};
